export const download = (url) => {
  var link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.style.visibility = "hidden";
  window.document.body.appendChild(link);
  link.click();
};
